export default __webpack_public_path__ + "static/media/Inventory.1bed5d1d.svg";